import React from 'react';
import { Form, FormikProps } from 'formik';

// Material UI
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';

// Data
import { getPlayerContactMessages } from '../player-contact.messages';

// Components
import { FocusFirstInvalidField } from '../../_core/Formik/focus-first-invalid-field.component';
import { PrimaryButton, SecondaryButton } from '../../_core/_ui/buttons.component';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { Spacer } from '../../_core/_ui/structure.components';
import { useCompanySport, useCompanySportTerminology } from '../../../lib/stores/company.store';
import { PlayerContactFields } from '../player-contact-fields.component';
import { IPlayerContactFormFields } from '../player-contact.types';

const FORM_ID = 'player-contact-form';

interface IPlayerContactForm {
  form: FormikProps<IPlayerContactFormFields>;
  onCancel?: Function;
  siblingContacts?: IPlayerContact[];
}

export const PlayerContactForm: React.FC<IPlayerContactForm> = ({ form, onCancel, siblingContacts = [] }) => {
  const { isSubmitting } = form;
  const sport = useCompanySport();
  const messages = getPlayerContactMessages(useCompanySportTerminology());

  return (
    <Form id={FORM_ID}>
      <FocusFirstInvalidField formId={FORM_ID} />
      <PlayerContactFields sport={sport} siblingContacts={siblingContacts} />

      <FormControl margin="dense">
        <Box display="flex" flexDirection="row">
          <PrimaryButton disabled={isSubmitting} type="submit">
            {isSubmitting ? <IntlMsg {...messages.btnSubmitting} /> : <IntlMsg {...messages.btnSubmit} />}
          </PrimaryButton>
          <Spacer />
          {onCancel && <SecondaryButton onClick={() => onCancel()}>Cancel</SecondaryButton>}
        </Box>
      </FormControl>
    </Form>
  );
};
